
































import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import { MapViewModel, MapService } from '../../api/map';

import global from '../../utils/global';

@Component({})
export default class FileList extends Vue {
  @Prop() private timelineItemId!: number;
  @Prop() private condition!: MapViewModel;

  private service: MapService = new MapService();
  private data: MapViewModel[] = [];
  private pageIndex: number = 1;
  private pageCount: number = -1;
  private totalCount: number = 0;

  // private timelineItemId: number = 0;
  private imgUrl: string = global.BACKGROUND_URL;

  private mounted() {
    // this.timelineItemId = parseInt(this.$route.query.id + '');
    if (this.timelineItemId > 0) {
      this.service.GetByTimeline(this.timelineItemId, 12).then((response: any) => {
        this.data = response;
      });
    } else if (this.condition !== undefined) {
      this.search(this.condition, 1);
    }
  }
  private search(condition: MapViewModel, pageIndex: number) {
    this.pageIndex = pageIndex;
    this.service.Search(condition, pageIndex).then((response: any) => {
      this.data = response.list;
      this.pageCount = response.pageCount;
      this.totalCount = response.totalCount;
      this.pageIndex = pageIndex;
      this.OnLoaded(response.totalCount);
    });
  }

  @Emit()
  private OnLoaded(totalCount: number) {
    return totalCount;
  }

  private page_OnChange(pageIndex: number) {
    this.search(this.condition, pageIndex);
    this.pageIndex = pageIndex;
  }
  private mapList_OnClick(item: MapViewModel) {
    this.$router.push({name: 'MapDetail', query: {id: item.id!.toString()}});
  }
  private btnAdd_OnClick() {
    this.$router.push({name: 'Map', query: {timelineitemid: this.timelineItemId.toString()}});
  }
}
